import { Injectable } from '@angular/core';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { BackgroundService } from 'backgroundservice';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  constructor(private geolocation: Geolocation) {}

  async getCurrentLocation(): Promise<{ latitude: number; longitude: number }> {
    // Try native Capacitor/Cordova first, fall back to browser API
    try {
      await BackgroundService.checkLocationPermission();
      const resp = await this.geolocation.getCurrentPosition({
        enableHighAccuracy: true,
        timeout: 20000
      });
      return {
        latitude: resp.coords.latitude,
        longitude: resp.coords.longitude
      };
    } catch (nativeErr) {
      console.warn('Native geolocation failed, trying browser API', nativeErr);
    }

    // Browser fallback
    if ('geolocation' in navigator) {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
          (pos) => resolve({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
          (err) => { console.error('Browser geolocation failed', err); reject(err); },
          { enableHighAccuracy: true, timeout: 20000 }
        );
      });
    }

    throw new Error('Geolocation not available');
  }

  watchPosition(callback: (pos: { latitude: number; longitude: number }) => void): any {
    // Try native first
    try {
      const watch = this.geolocation.watchPosition({ enableHighAccuracy: true });
      const subscription = watch.subscribe((data: any) => {
        if (data && data.coords) {
          callback({ latitude: data.coords.latitude, longitude: data.coords.longitude });
        }
      });
      return subscription;
    } catch {
      // Browser fallback
      if ('geolocation' in navigator) {
        const watchId = navigator.geolocation.watchPosition(
          (pos) => callback({ latitude: pos.coords.latitude, longitude: pos.coords.longitude }),
          () => {},
          { enableHighAccuracy: true }
        );
        return { unsubscribe: () => navigator.geolocation.clearWatch(watchId) };
      }
      return null;
    }
  }

  stopWatching(subscription: any): void {
    if (subscription && subscription.unsubscribe) {
      subscription.unsubscribe();
    }
  }
}
